/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddDeviceController($scope, $mdDialog, $state, $stateParams, $document, $q, types, deviceService,
                                            networkSettingsService, apiLimitsService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {
            networkSettings: networkSettingsService.createDefaultNetworkSettings(),
            apiLimits: apiLimitsService.createDefaultApiLimits()
        };

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        if ($stateParams.applicationId) {
            vm.entity.applicationId = {
                entityType: types.entityType.application,
                id: $stateParams.applicationId
            };
        }
        var newNetworkSettings = vm.entity.networkSettings;
        var newApiLimits = vm.entity.apiLimits;
        var fCnts = vm.entity.fCnts;
        deviceService.saveDevice(vm.entity).then(
            (entity) => {
                vm.entity = entity;
                deviceService.saveDeviceFCnts(vm.entity.id.id, fCnts).then(
                    (fCnts) => {
                        vm.entity.fCnts = fCnts;
                        networkSettingsService.getNetworkSettings(entity.id.entityType, entity.id.id).then(
                            (networkSettings) => {
                                newNetworkSettings.entityId = networkSettings.entityId;
                                newNetworkSettings.id = networkSettings.id;
                                networkSettingsService.saveNetworkSettings(newNetworkSettings).then(
                                    (networkSettings) => {
                                        vm.entity.networkSettings = networkSettings;
                                        apiLimitsService.getApiLimits(entity.id.entityType, entity.id.id).then(
                                            (apiLimits) => {
                                                newApiLimits.entityId = apiLimits.entityId;
                                                newApiLimits.id = apiLimits.id;
                                                apiLimitsService.saveApiLimits(newApiLimits).then(
                                                    (apiLimits) => {
                                                        vm.entity.apiLimits = apiLimits;
                                                        $scope.theForm.$setPristine();
                                                        $mdDialog.hide();
                                                    }
                                                );
                                            }
                                        );
                                    }
                                );
                            }
                        );
                    }
                );
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/device/add-device.controller.js